import React from 'react';
import { TabF, TabsF } from 'components/tabs/tabfile';
import RemindersTabName from 'components/invoiceReminders/RemindersTabName';
import UseContext from 'hooks/useContext';

// `remindersToDo`: the count of "À faire" of the reminders (JBWEB-1283), shown on their tab.
const PayslipManagementSubNav = ({ remindersToDo }) => {
  const { language } = UseContext();
  const text = (key, fallback) =>
    language.getValue(`invoiceList.${key}`, fallback);

  return (
    <TabsF>
      <TabF label={'payslips'} tabName={'Fiches de paie'} />
      <TabF
        label={'invoices'}
        tabName={text('tabInvoices', 'Factures clients')}
      />
      <TabF
        label={'reminders'}
        tabName={
          <RemindersTabName
            label={text('tabReminders', 'Rappels / Relances')}
            toDo={remindersToDo}
          />
        }
      />
    </TabsF>
  );
};

export default PayslipManagementSubNav;
